import { render, staticRenderFns } from "./SearchbarPathText.vue?vue&type=template&id=4acd94a2&scoped=true&"
import script from "./SearchbarPathText.vue?vue&type=script&lang=ts&"
export * from "./SearchbarPathText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acd94a2",
  null
  
)

export default component.exports